module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"cancel":"Retour","save":"Enregistrer","loading":"Chargement...","modifyInformations":"Modifier la propriété","send":"Envoyer","download":"Télécharger","upload":"Téléverser (vers la GED)"}}')
  delete Component.options._Ctor
}
